import { byId, isAr, copyText, saveBlob, trackEvent } from './extra-common.js';
import { detectUserCountry, detectUserCurrency, COUNTRY_TO_CURRENCY } from './countries-data.js';

export { byId, isAr, saveBlob, trackEvent, detectUserCountry, detectUserCurrency, COUNTRY_TO_CURRENCY };

export function formatNumber(val, maxDecimals = 2) {
  if (val === null || val === undefined || isNaN(val)) return '0';
  const num = Number(val);
  return num.toLocaleString(isAr ? 'ar-EG' : 'en-US', {
    maximumFractionDigits: maxDecimals,
    minimumFractionDigits: 0
  });
}

export function formatCurrency(val, currency = 'SAR') {
  if (val === null || val === undefined || isNaN(val)) return '0';
  const num = Number(val);
  const formatted = num.toLocaleString(isAr ? 'ar-EG' : 'en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2
  });
  return `${formatted} ${currency}`;
}

export function attachCopyButton(btn, getTextToCopy, successMsg = '') {
  if (!btn) return;
  const originalHtml = btn.innerHTML;
  btn.addEventListener('click', async () => {
    try {
      const text = typeof getTextToCopy === 'function' ? getTextToCopy() : getTextToCopy;
      if (!text) return;
      await copyText(text);
      btn.classList.add('copied');
      btn.innerHTML = `
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        <span>${successMsg || (isAr ? 'تم النسخ!' : 'Copied!')}</span>
      `;
      setTimeout(() => {
        btn.classList.remove('copied');
        btn.innerHTML = originalHtml;
      }, 2000);
    } catch (err) {
      console.warn('Copy failed', err);
    }
  });
}

export function setupSegmented(containerId, onSelect) {
  const container = typeof containerId === 'string' ? byId(containerId) : containerId;
  if (!container) return;
  const btns = Array.from(container.querySelectorAll('.kz-segment-btn'));
  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      btns.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      if (typeof onSelect === 'function') {
        onSelect(btn.dataset.value || btn.dataset.tab || btn.textContent.trim(), btn);
      }
    });
  });
}

export function setupLiveCalculation(inputIds, calcFn) {
  const toolSlug = (typeof window !== 'undefined' && window.__KZ_TOOL_SLUG__) ||
    window.location.pathname.replace(/^\/|\/$/g, '').split('/')[0];

  let hasStarted = false;
  let debounceTimer = null;

  const triggerLive = () => {
    if (!hasStarted) {
      hasStarted = true;
      trackEvent('tool_started', toolSlug);
    }
    try {
      calcFn();
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        trackEvent('tool_completed', toolSlug);
      }, 600);
    } catch (err) {
      console.error(err);
      trackEvent('tool_failed', toolSlug);
    }
  };

  inputIds.forEach((id) => {
    const el = byId(id);
    if (!el) return;
    el.addEventListener('input', triggerLive);
    el.addEventListener('change', triggerLive);
  });

  // Initial run without tracking (page load initial display)
  try {
    calcFn();
  } catch (err) {
    console.error(err);
  }
}
